import { Type } from 'class-transformer';
import { IsDateString, IsInt, IsOptional, Max, Min } from 'class-validator';

/**
 * Body for `POST /iot/sensors/:sensorId/calibration-certificate`.
 *
 * The certificate PDF travels as multipart `file`; this DTO carries only the
 * expiry metadata. Reminder scheduling is owned by `DocumentExpiryNotificationCron`
 * against `SignedDocument.expiresAt`, so no new notification types are introduced.
 */
export class AttachCalibrationCertificateDto {
  /** ISO-8601 datetime: when the laboratory calibration expires. */
  @IsDateString()
  expiresAt!: string;

  /**
   * Lead time (days) for the expiring-soon reminder. Defaults to the
   * `SignedDocument` standard when omitted.
   */
  @IsOptional()
  @Type(() => Number)
  @IsInt()
  @Min(0)
  @Max(365)
  expiryWarningDays?: number;
}
